import { ProductCardStatus } from "@/api/types/main/schemas";
import { FC } from "react";
import { Badge } from "../ui/badge";
import { getHumanReadableProductCardStatus } from "@/api/types/helpers/functions";

interface StatusAmSelectFormProps {
  statusAm: ProductCardStatus;
}

//TODO: ЗАМЕНИТЬ НА ФОРМУ
const StatusAmSelectForm: FC<StatusAmSelectFormProps> = ({ statusAm }) => {
  const humanReadableStatusAm = getHumanReadableProductCardStatus(statusAm);
  return (
    <Badge
      className={`${humanReadableStatusAm.color} hover:${humanReadableStatusAm.color} hover:opacity-80 w-24 flex justify-center items-center whitespace-nowrap`}
    >
      {humanReadableStatusAm.value}
    </Badge>
  );
};

export default StatusAmSelectForm;
